function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-1 0 0 1 25 0)",
  fill: "url(#pagination-left-arrow_svg__pattern0)",
  d: "M0 0h25v25H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pagination-left-arrow_svg__pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pagination-left-arrow_svg__image0",
  transform: "scale(.01563)"
})), /*#__PURE__*/React.createElement("image", {
  id: "pagination-left-arrow_svg__image0",
  width: 64,
  height: 64,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAADgElEQVR4Xu2aS2hTQRRA731RUakkUUFjRFEUFHEjaBcKumirRVH8ZCminTfQItKluAlZiRsLbkxmkrQLQUWpoJbiZ+HCjQgudCEoKPgJCKJWFwr5XBl4QhysefmVeZ9sMy/knHtn3p07gxDwDwacH0IBYQYE3EA4BQKeAOEiGE6BcAoE3EA4BUxJANu2BwEgDwBERGfy+fzkXPw3YzLAtu0PAJB0oKsAwKWUxW5LMFWA4iZEHBVCXOqmBGMEMMYOIeINAJivAZ+TUp7vlgRjBChAzvl+IlISFmnAF6SUZ7shwSgBCtC27d0AcAcAltQDE9HlZDJ5OpPJ1DopwjgBjoTtRDSNiMvqYRHxSiKROJnJZCqdkmCkAEfCFgB4AAAJTcJ1ADguhCh3QoKxApw1YRMRKQmrNdipnp6e1NjY2M92JRgtQMENDQ2ttSzrIQBs0GAfVavVg8Vi8Uc7EowXoOBGRkZWlsvl+wCwVYN9WqvV9hUKhS+tSvCEACcTllqWNQ0AOzTYZ4i4VwjxuRUJnhHgrAlRIpoCgJ0a7MtIJNKfzWY/NivBUwIcCYuJ6BYADGiwbyuVSt/4+PibZiR4ToCCS6VSC+Lx+FUiOqLBvrMsqy+Xy712K8GTAhwJkWg0WkDEExrsJyIayOfzz91I8KwABZdOp61SqZRVFbQG+xURB4UQTxpJ8LQABw455xeJaFSD/QYAvVLKV/+T0FCAs0PL1TUrGkk15ntEnBRCHG1LgG3b7/9RihoD2eCPfJdSRoMsYEZKGWtXgGpWCi9mQUemgOm5nkqlIrFYTAXoVFcWQZMFpNPpeaVSSXWOjwfuNaiqwVgsdg0ADuuFECL2CyFeuAlew9egmx+Z6zGc89n2A/4vhTnns+0I/b8ZGh4ejlcqFdUT6NW3w9Vqta9YLJaazUbPTAHG2ApEVP1BvSvk/4YI53wNEam+4EYtwo8R8YAQYqbZyP8Zb3wGMMbWqaYoEa3XIP3fFGWMbUZEFflVGvxUuVw+NjEx8avVyBufAZzzbUR0DwCW10Miov8PRjjnu4joLgD8tZMLxNEYY2wPIt4O5OGo03y5CQALtbnt/+PxwF+Q0O4IqQQI1hWZ8JKUbQ8iomq+Qq1WGw3cNbl2C5pWnze+FG4VzO1zoQC3pvw6LswAv0bWLVeYAW5N+XVcmAF+jaxbrjAD3Jry67jffYBEUOmaEVIAAAAASUVORK5CYII="
}));

function SvgPaginationLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgPaginationLeftArrow;